export default {
    BLACK: 'BLACK',
    YELLOW: 'YELLOW',
    RED: 'RED',
};
